"use client";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

export function ApplicatorCta() {
  return (
    <section
      id="applicators-cta"
      className="py-24 bg-foreground/5 text-card-foreground dark:bg-stone-900 dark:text-foreground transition-colors"
      data-header-scheme="dark"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <h2 className="font-serif text-3xl md:text-4xl font-light mb-6 tracking-tight">
            Don&apos;t See Your City of Interest?
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            We&apos;re constantly expanding our network of certified
            applicators. Contact us to find professionals in your area or to
            become a certified applicator.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="outline"
              size="lg"
              className="border-border text-foreground hover:bg-foreground hover:text-background"
            >
              Contact Us
            </Button>
            <Button
              size="lg"
              className="bg-foreground text-background hover:bg-foreground/90"
            >
              Become an Applicator
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
